// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyCw-4DY4rKDROfyu9nU3bB2ui7deyxv6fo",
    authDomain: "ibank-astro.firebaseapp.com",
    projectId: "ibank-astro",
    storageBucket: "ibank-astro.firebasestorage.app",
    messagingSenderId: "943589977867",
    appId: "1:943589977867:web:e56d15c900cd22fb5b3c0e",
    measurementId: "G-5YPYXCE6C8"
  };
  

  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app);

export { db }; 


// Import the functions you need from the SDKs you need
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// Initialize Firebase
